var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.ProgressBar},[_c('div',{class:_vm.$style.Track},[_c('div',{class:_vm.$style.InnerTrack}),_c('div',{class:_vm.$style.Bar,style:('width: ' + _vm.percent + '%')})])])}
var staticRenderFns = []

export { render, staticRenderFns }